import React from 'react';

/**
 * GameOver — Death screen overlay
 *
 * Shows final stats and restart button.
 */

const styles = {
  overlay: {
    position: 'absolute',
    top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(6, 6, 12, 0.92)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 200,
    fontFamily: "'Orbitron', sans-serif",
    animation: 'fadeIn 0.5s ease-out',
  },
  title: {
    fontSize: '36px',
    fontWeight: 900,
    color: '#ff0040',
    marginBottom: '6px',
    textShadow: '0 0 30px rgba(255, 0, 64, 0.6)',
    letterSpacing: '4px',
  },
  subtitle: {
    fontSize: '12px',
    color: '#888',
    letterSpacing: '3px',
    marginBottom: '30px',
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '16px 40px',
    marginBottom: '36px',
    textAlign: 'center',
  },
  statLabel: {
    fontSize: '10px',
    color: '#666',
    letterSpacing: '2px',
    textTransform: 'uppercase',
    marginBottom: '4px',
  },
  statValue: {
    fontSize: '22px',
    fontWeight: 700,
    letterSpacing: '1px',
  },
  restartBtn: {
    padding: '14px 40px',
    fontSize: '14px',
    fontWeight: 700,
    fontFamily: "'Orbitron', sans-serif",
    letterSpacing: '3px',
    color: '#00ff41',
    background: 'transparent',
    border: '2px solid #00ff41',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: '0 0 15px rgba(0, 255, 65, 0.2)',
    pointerEvents: 'auto',
    textTransform: 'uppercase',
  },
};

export default function GameOver({ stats, onRestart }) {
  const { score = 0, kills = 0, level = 1, timeSurvived = 0, wave = 1 } = stats || {};
  const minutes = Math.floor(timeSurvived / 60);
  const seconds = Math.floor(timeSurvived % 60);
  const timeStr = `${minutes}:${seconds.toString().padStart(2, '0')}`;

  return (
    <div style={styles.overlay}>
      <div style={styles.title}>SYSTEM FAILURE</div>
      <div style={styles.subtitle}>CONNECTION LOST</div>

      <div style={styles.statsGrid}>
        <div>
          <div style={styles.statLabel}>SCORE</div>
          <div style={{ ...styles.statValue, color: '#00ff41' }}>{score.toLocaleString()}</div>
        </div>
        <div>
          <div style={styles.statLabel}>KILLS</div>
          <div style={{ ...styles.statValue, color: '#ff6600' }}>{kills}</div>
        </div>
        <div>
          <div style={styles.statLabel}>LEVEL</div>
          <div style={{ ...styles.statValue, color: '#a855f7' }}>{level}</div>
        </div>
        <div>
          <div style={styles.statLabel}>SURVIVED</div>
          <div style={{ ...styles.statValue, color: '#00d4ff' }}>{timeStr}</div>
        </div>
        <div>
          <div style={styles.statLabel}>WAVE</div>
          <div style={{ ...styles.statValue, color: '#ffcc00' }}>{wave}</div>
        </div>
      </div>

      <button
        style={styles.restartBtn}
        onClick={onRestart}
        onMouseEnter={e => {
          e.currentTarget.style.background = 'rgba(0, 255, 65, 0.15)';
          e.currentTarget.style.boxShadow = '0 0 25px rgba(0, 255, 65, 0.4)';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.background = 'transparent';
          e.currentTarget.style.boxShadow = '0 0 15px rgba(0, 255, 65, 0.2)';
        }}
      >
        JACK BACK IN
      </button>
    </div>
  );
}
